import React, { useEffect, useState } from 'react';
export function useCountdown(initialHours = 23, initialMinutes = 59, initialSeconds = 48) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return timeLeft;
}
export const CountdownDisplay = ({
  hours,
  minutes,
  seconds
}: {
  hours: number;
  minutes: number;
  seconds: number;
}) => {
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center gap-2 font-bold text-lg sm:text-xl" data-id="element-55">
      <div className="bg-white/20 px-2 py-1 rounded" data-id="element-56">{pad(hours)} hs</div>
      <span data-id="element-57">:</span>
      <div className="bg-white/20 px-2 py-1 rounded" data-id="element-58">{pad(minutes)} min</div>
      <span data-id="element-59">:</span>
      <div className="bg-white/20 px-2 py-1 rounded" data-id="element-60">{pad(seconds)} seg</div>
    </div>;
};